module.exports = __webpack_public_path__ + "img/bus_stopped.03615fea.svg";